<template>
  <div class="iframe-wrapper">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.iframe-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* Default for 1600x900 videos 16:9 ratio*/
  padding-top: 0;
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
